<app-navbar-style-two></app-navbar-style-two>
<app-seo-agency></app-seo-agency>

<div class="container">
    <div class="row align-items-center pt-5">
      <div class="col-lg-6 p-5">
        <h1 class="highlight-title">
            Transform Your Real <br>
            Estate Sales with<br>
             RingPilot
        </h1>
        <p class="sub-text mt-4">
            Dial More Contacts, Close More Deals, and Grow Your Real Estate Empire
        </p>
        <button class="btn btn-custom start-btn fw-bold d-flex align-items-center justify-content-center px-4" routerLink="/contact">
            <i class="bi bi-fire"></i> Started Now 
        </button>
      </div>
  
      <div class="col-lg-6 image-container d-none d-lg-block">
        <img src="assets/img/industries/hero-section.jpg" alt="image">
      </div>
    </div>
</div>

<!--------Introduction------------>
<div class="service-area-two pt-50 pb-70">
    <div class="container">
        <div class="row align-items-center m-5">
          <div class="col-lg-6 p-5">
             <img src="assets/img/industries/real-estate-image3.jpg" alt="Real Estate" class="img-fluid rounded shadow-sm" />
          </div>
      
          <div class="col-md-6">
            <h2 class="mb-3">Introduction</h2>
            <p>
                Welcome to <strong>RingPilot's Real Estate Dialer</strong>, the ultimate tool designed to revolutionize your real
                 estate business. Our advanced dialer automates your calling process, allowing you to reach more 
                 potential clients, manage leads efficiently, and close more deals.
            </p>
            <p>
                Experience a seamless blend of
                technology and performance tailored specifically for real estate professionals
            </p>
          </div>
        </div>
    </div>
</div>

<!--------- What is a Real Estate Dialer? -------->

<div class="service-area-two pt-50 pb-70">
    <div class="container">
        <div class="text-center">
            <h2>What is a Real Estate Dialer?</h2>
        </div>
        <div class="row align-items-center">
    
            <div class="col-md-6 p-5">
                <p>
                    A <strong>real estate dialer</strong> is a powerful tool that automates the process of 
                    dialing potential clients, enabling real estate professionals to reach
                     more contacts in less time. By eliminating manual dialing, our dialer
                      helps you manage large volumes of leads efficiently and increase your sales.
                </p>
              </div>
              <div class="col-lg-6 p-5">
                <img src="assets/img/industries/dialer-image.jpg" alt="Real Estate" class="img-fluid rounded shadow-sm" />
             </div>
    
        </div>
    </div>
</div>

<!--------- Key Benefits -------->
<div class="service-area-two pt-50 pb-70">
    <div class="container">
        <div class="text-center">
            <h2>Key Benefits</h2>
        </div>

        <div class="row pt-45 ">
            <div class="col-lg-4 col-md-6">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Increase Productivity</a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon7.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p> Automate repetitive tasks and focus on high-value activities.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Enhance Lead Management</a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon8.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p>Efficiently manage and nurture leads with advanced dialing features.</p>
                    
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Boost Sales </a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon9.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p>Reach more prospects in less time, increasing your chances of closing deals.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="service-two-shape">
        <div class="shape-in1"><img src="assets/img/shape/shape9.png" alt="Images"></div>
        <div class="shape-in2"><img src="assets/img/shape/shape10.png" alt="Images"></div>
        <div class="shape-in3"><img src="assets/img/shape/shape11.png" alt="Images"></div>
        <div class="shape-in4"><img src="assets/img/shape/shape7.png" alt="Images"></div>
        <div class="shape-in5"><img src="assets/img/shape/shape12.png" alt="Images"></div>
    </div>
</div>

<!--------- How Our Real Estate Dialer Nurtures Your Business -------->
<div class="service-area-two pt-50 pb-70" style="background-color: #f5f8ff;">
    <div class="container">
        <div class="text-center">
            <h2>How Our Real Estate Dialer Nurtures Your Business</h2>
        </div>

        <div class="row pt-45 ">

          <div class="row g-4">
           
            <div class="col-md-4">
              <div class=" bg-white text-center p-4 rounded shadow-sm h-100">
                <div class="mb-3">
                  <i class="bi bi-diagram-3-fill fs-1 text-primary"></i>
                </div>
                <h5 class="fw-semibold">Streamlined Workflow</h5>
                <p>Simplify complex tasks such as note-taking, call logging, and follow-ups. Our dialer keeps actions organized to boost agent productivity.</p>
              </div>
            </div>
          
            <div class="col-md-4">
              <div class=" bg-white text-center p-4 rounded shadow-sm h-100">
                <div class="mb-3">
                  <i class="bi bi-cloud-check-fill fs-1 text-primary"></i>
                </div>
                <h5 class="fw-semibold">No Installation Required</h5>
                <p>Our cloud-based dialer works out-of-the-box—just log into your CRM, queue your list, and start dialing instantly.</p>
              </div>
            </div>
          
            <div class="col-md-4">
              <div class=" bg-white text-center p-4 rounded shadow-sm h-100">
                <div class="mb-3">
                  <i class="bi bi-ui-checks-grid fs-1 text-primary"></i>
                </div>
                <h5 class="fw-semibold">User-Friendly Interface</h5>
                <p>Enjoy an intuitive interface built for real estate agents. Make calls, send texts, and manage customer history from one screen.</p>
              </div>
            </div>
          </div>
          

        </div>
    </div>

</div>



<!------- Different Dialing Modes Supported------->

<section class="py-5">
    <div class="container">
      <h2 class="text-center  mb-5">Different Dialing Modes Supported</h2>
      <div class="row g-4">
        
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-lightning-charge-fill fs-1 text-primary"></i>
            </div>
            <h5 class="fw-semibold">Power Dialing</h5>
            <p>Automatically dial numbers sequentially from your list for faster outreach.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-eye-fill fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">Preview Dialing</h5>
            <p>View numbers before dialing and choose which ones to call for more control.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-telephone-forward-fill fs-1 text-info"></i>
            </div>
            <h5 class="fw-semibold">App Dialing</h5>
            <p>Use apps like Google Voice, Skype, and more for auto-dialing flexibility.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-hourglass-split fs-1 text-warning"></i>
            </div>
            <h5 class="fw-semibold">Uninterrupted Mode</h5>
            <p>Focus on continuous dialing without pop-ups or distractions.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-whatsapp fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">WhatsApp Mode</h5>
            <p>Automate sending WhatsApp messages to your contacts easily.</p>
          </div>
        </div>
  
      </div>
    </div>
</section>

<!--------- Real Estate Dialer + CRM Integration -------->

<div class="service-area-two pt-50 pb-70">
  <div class="container">
      <div class="text-center">
          <h2>Real Estate Dialer + CRM Integration</h2>
      </div>
      <div class="row align-items-center">
          <div class="col-lg-6 p-5">
             <img src="assets/img/industries/dialer2.jpg" width="100%" alt="image" class="img-fluid rounded shadow-sm" />
          </div>
          <div class="col-md-6 p-5">
              <p>
                Our dialer comes with an integrated CRM to help you manage leads and
                 track conversations. This ensures that you never miss a follow-up 
                 and can easily send SMS or WhatsApp messages when needed.
              </p>
          </div>
      </div>
  </div>
</div>
  
<!------- Features of Our Dialer Software----------->
<div class="container my-5">
  <h2 class="mb-4">Features of Our <span style="color: #FF5A2C;">Dialer Software</span></h2>

  <div class="row align-items-start">

    <div class="col-md-9">
      <div *ngFor="let faq of faqs; let i = index" class="faq-item p-2 mb-3 border rounded bg-light">
        <div class="faq-header d-flex justify-content-between align-items-center">
          <span class="fw-bold">{{ faq.question }}</span>
          <span
            class="faq-toggle fs-4"
            style="cursor:pointer;"
            (click)="toggleFaq(i)"
          >
            {{ selectedFaqIndex === i ? '×' : '+' }}
          </span>
        </div>
        <div class="faq-content mt-2" *ngIf="selectedFaqIndex === i">
          <div style="height: 1px; background-color: #ff5a2c; margin-bottom: 8px;"></div>
          <p [innerHTML]="faq.answer"></p>
        </div>
      </div>
    </div>

    <div class="col-md-3 d-flex justify-content-center align-items-center">
      <img src="assets/img/industries/features.jpg" alt="image">
    </div>
  </div>
</div>

<!------- testimonials ----------->
<div class="container py-5">
  <div class="text-center mb-5">
    <h2 class="text-dark">Client Testimonials</h2>
    <p>Showcase testimonials from satisfied clients to build trust and credibility.</p>
  </div>

  <div class="row justify-content-center">

    <div class="col-md-5 col-sm-12 mb-4">
      <div class="testimonial-card border border-orange rounded-4 p-4 text-center h-100">
        <img src="assets/img/home-two/person2.jpg" alt="CEO Photo" class="img-fluid rounded-circle mb-3" width="120">
        <p class="text-muted">
          "RingPilot has revolutionized our real estate operations. The dialer is intuitive and has
           significantly boosted our sales."
        </p>
        <h5 class="fw-bold mb-0"> - John D., Real Estate Agent</h5>
      </div>
    </div>

  </div>
</div>

<!-------Other Sectors We Support-------->
<section class="other-sectors py-5 bg-light">
  <div class="container">
    <h2 class="text-center mb-4 text-black">Other Sectors We Support</h2>

    <div class="scroll-container d-flex gap-4 overflow-auto px-2">
      <a href="/insurance" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-shield-check fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">Insurance</h5>
        </div>
      </a>

      <a href="/ed-tech" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-mortarboard fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">Ed Tech</h5>
        </div>
      </a>

      <a href="/banking" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-bank fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">Banking</h5>
        </div>
      </a>

      <a href="/health-care" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-heart-pulse fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">Healthcare</h5>
        </div>
      </a>

      <a href="/bpo-dialer" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-people-fill fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">BPO</h5>
        </div>
      </a>

      <a href="/solar-dialer" class="text-decoration-none sector-link">
        <div class="sector-card p-4 bg-white rounded shadow-sm text-center flex-shrink-0">
          <i class="bi bi-sun-fill fs-1 mb-2 icon-color"></i>
          <h5 class="fw-semibold text-black">Solar</h5>
        </div>
      </a>      
    </div>
  </div>
</section>



<!--------CTA-------->
<div class="history-area pt-100 pb-70">
  <div class="container">
      <div class="text-center mb-5">
          <h2>Try RingPilot for Free</h2>
      </div>

      <div class="row">
          <div class="col-lg-6 col-md-12 d-flex align-items-center">
              <div class="history-content">
                  <p>Experience the benefits of our advanced auto and predictive dialer software.
                  </p>
                  <!-- <a routerLink="/about" class="default-btn">Learn more <i class='bx bx-plus'></i></a> -->
                  <button class="btn start-btn fw-bold d-flex align-items-center justify-content-center px-4" routerLink="/contact">
                      <i class="bi bi-fire me-1"></i> Request a Demo
                  </button>
              </div>
          </div>

          <div class="col-lg-6 col-md-12">
              <div class="history-img">
                  <img src="assets/img/industries/cta.jpg" alt="Images">
              </div>
          </div>
      </div>
  </div>
</div>


<app-footer-style-two></app-footer-style-two>
